import React, { useContext, useState } from 'react';
import { ReportsContext } from '../context';
import LoadingDisplay from './loading-display';
import ErrorDisplay from './error-display';
import { createPortal } from 'react-dom';
import classnames from 'classnames';
import style from './style.module.less';

const ReportOutput = () => {
  const { isReportGenerationProcessing, reportOutput, hasReportGenerationError } = useContext(ReportsContext);
  const [contentRef, setContentRef] = useState(null);
  const mountNode = contentRef?.contentWindow?.document?.body;
  const shouldShowReportContents = !isReportGenerationProcessing && !hasReportGenerationError;
  const hasReportContent = !!reportOutput;
  return (
    <div className={style['report-output-wrapper']}>
      {isReportGenerationProcessing && <LoadingDisplay />}
      {hasReportGenerationError && <ErrorDisplay />}
      {shouldShowReportContents && (
        <iframe
          ref={setContentRef}
          className={classnames(style['report-output'], {
            [style['has-content']]: hasReportContent,
          })}
          title='report output iframe'
        >
          {mountNode &&
            createPortal(
              // oxlint-disable-next-line react/no-danger
              <span dangerouslySetInnerHTML={{ __html: reportOutput }} />,
              mountNode,
            )}
        </iframe>
      )}
    </div>
  );
};

export default ReportOutput;
